import { msg } from '@lingui/core/macro';

import { getAxiosInstance } from '@rover/rsdk/src/modules/Network/axios';
import type { Snakeify } from '@rover/rsdk/src/modules/Network/object-utilities';
import { camelize } from '@rover/rsdk/src/modules/Network/object-utilities';
import type { PersonSitterProfileResponse } from '@rover/types/src/apiResponses/PersonSitterProfileResponse';
import { ApiErrorMessage } from '@rover/utilities/apiErrorMessage';
import { emitErrorApiCallMetric, emitSuccessApiCallMetric } from '@rover/utilities/emitMetricUtils';

import DefaultAPIErrorHandler from './DefaultAPIErrorHandler';

export const GET_ERROR = ApiErrorMessage.fromDescriptor(
  msg({
    id: 'apiError.personSitterProfile.getError',
    message: `There was an error fetching the sitter profile.`,
  })
);

// Mirrors SitterProfileStayQuoteMixin.REQUOTE_HEADER, which skips recording a profile view.
export const PROFILE_REQUOTE_HEADER = 'X-Rover-Profile-Requote';

export const get = async (
  personSitterProfileUrl: string,
  { headers }: { headers?: Record<string, string> } = {}
): Promise<PersonSitterProfileResponse> => {
  const ai = getAxiosInstance();

  try {
    const { data } = await ai.get<Snakeify<PersonSitterProfileResponse>>(
      personSitterProfileUrl,
      headers ? { headers } : undefined
    );
    emitSuccessApiCallMetric('personSitterProfile', 'GET');
    return camelize(data, true);
  } catch (error: any) {
    emitErrorApiCallMetric('personSitterProfile', 'GET');
    return DefaultAPIErrorHandler(error, GET_ERROR);
  }
};
